//
// Components

import ProductFilter from './components/ProductFilter';
import Map from './components/Map';
import Forms from './components/Forms';
import NativeForms from './components/NativeForms';
import PhotoSwipe from './components/PhotoSwipe';

//
// Tools

import ABuilder from "./tools/ABuilder";
import Ajax from "./tools/Ajax";
import AData from "./tools/AData";
import Events from "./tools/Events";
import Constants from "./tools/Constants";
import Search from './components/Search';
import Tools from './tools/Tools';

/**
 * APART Script
 */


let Apart = {

	init() {

		console.log('Starting lus ...');

		this.checkTouchSupport();

		this.Map = new Map();
		this.attachSearch();
		this.attachHomeTabs();
		this.attachInfosScroll();

		this.attachNavigation();
		this.attackLinkScroll();
		this.attachNonLinkScroll();
		this.attachDateSelectorScroll();

		this.attachForms()
		
		this.attachAlert();

		this.autoAccordionScrolling();

		this.bindMailto();

		this.scrollToAnchor();

		this.eventsSlider();

		this.placesSlider();

		this.linkBoxesSlider();

		this.eventFilter();
		
		this.subSavoirFaireLink();
		
		this.toggleFooterLinks();

	},

	/**
	 * @author NGUYEN Duc Quan
	 */
	checkTouchSupport() {

		let touchSupport = ('ontouchstart' in window);

		if (touchSupport === false) {
			$('body').addClass('no-touch');
		}

	},

	attachHomeTabs() {
		let homeContent = $('.home-content-lus');
		let navLink = $('.nav-main-menu li a');

		navLink.on('click', (e) => {
			if (homeContent.is(':visible')) {
				let navItems = $('.nav-main-menu li');
				e.preventDefault();
				let target = $(e.target);
				navItems.removeClass('is-selected');
				target.parent().addClass('is-selected');

				homeContent.find('> div').removeClass('is-visible');
				homeContent.find('.' + target.attr('class')).addClass('is-visible');
			}
		});
	},

	attachInfosScroll() {
		let rightInfos = $('.right-infos-block');
		let mainContainer = $('.content-main');
		let leftContentBlock = $('.left-content');

		if (rightInfos.length > 0) {
			let leftContentBlockTop = leftContentBlock.outerHeight();
			let rightInfosTop = rightInfos.offset().top;
			let rightInfosBottom = rightInfosTop + rightInfos.outerHeight();
			let leftContentBlockBottom = leftContentBlockTop + leftContentBlock.outerHeight();
			if (rightInfosBottom < leftContentBlockBottom) {
				rightInfos.affix({
					offset: {
						top: rightInfosTop - 15,
						bottom: mainContainer.next('div').outerHeight(true) + $('.snookfun-footer').outerHeight(true) + 50
					}
				});
			}
			return false;
		}
	},

	attachSearch() {
		this.search = new Search;
	},

	attachNavigation() {
		this.flkty = null;
		this.navWidth = 70;

		//nav elements size
		$('.bcee-nav-main .main-logo, .bcee-nav-main .main-links LI').each((aIndex, aElement) => {
			this.navWidth += $(aElement).width();
		});

	},

	attackLinkScroll() {

		$('A.link-scroll').each((aIndex, aElement) => {

			let element = $(aElement);
			let target = element.attr('href');

			element.on('click touch', (event) => {

				event.stopPropagation();
				event.preventDefault();

				$('html, body').animate({
					scrollTop: $(target).offset().top - 20
				}, 1000);

			});

		});

	},

	attachNonLinkScroll() {

		$('.non-link-scroll').each((aIndex, aElement) => {

			let element = $(aElement);

			element.on('click touch', (event) => {

				$('html, body').animate({
					scrollTop: element.offset().top - 20
				}, 1000);

			});

		});

	},

	attachForms() {

		this.forms = new Forms();
		this.forms = new NativeForms();

		Events.register(Constants.Events.AJAX_FORM_RESPONDED, (aData) => {

			console.log(aData);

			switch (aData.formKey) {

				case "simulator.pret.plus":

					// ---

					break;

			}

			return true;

		});

	},
	
	attachAlert(){

		$('.snookfun-alert').each((aIndex, aElement) => {
			
			let alertElement = $(aElement);
			let closeButton = alertElement.find('.alert-close');
			let uid = alertElement.data('uid');

			if (Tools.readCookie('lusAlert' + uid) !== null) {
				alertElement.remove();
			} else {
				alertElement.show();
			}
			alertElement.show();
			closeButton.on("click", () => {
				alertElement.remove();
				Tools.writeCookie('lusAlert' + uid, true, 364); // 1 year
			});
		});
	},

	attachDateSelectorScroll() {
		let dateSelector = $('.date-selector');
		let listContainer = $('.full-event-list');

		if (dateSelector.length > 0) {
			let listContainerTop = listContainer.offset().top;
			dateSelector.affix({
				offset: {
					top: listContainerTop +68,
					bottom: $('.snookfun-footer').outerHeight(true) + 150
				}
			});

			// function scrollActive(currentId) {
			// 	$('[id^="currentMonth-"]').removeClass('active');
			// 	$(currentId).addClass('active');
			// }
			//
			// $('.date-selector li.month').on('activate.bs.scrollspy', function(e) {
			// 	var targetId = $(e.target).find('a').attr('href');
			// 	scrollActive(targetId);
			// console.log(targetId);
			// });

			dateSelector.find("li").on("click", function () {
				dateSelector.find("li").removeClass("active");
				$(this).addClass("active");
			});

		}

	},

	autoAccordionScrolling() {
		$('a', '#accordion').on('click', function () {
			let __this = $(this);
			setTimeout(function () {
				var offset = __this.offset();
				if (!__this.hasClass('collapsed')) {
					$('html,body').animate({scrollTop: offset.top}, 400);
				}
				return false;
			}, 400);
		});
	},

	bindMailto() {
		$('.mailto').on('click', (e) => {

			e.preventDefault();

			let thisElement = e.currentTarget;

			window.location.href = $(thisElement).attr('href').replace('[at]', '@');

		});
	},

	scrollToAnchor() {
		let aHref = $('a[href*=\\#]');
		aHref.on('click', function (event) {
			if (aHref.hasClass('panel-header-link') === false) {
				event.preventDefault();
				$('html,body').animate({scrollTop: $(this.hash).offset().top}, 500);
			}
		});
	},

	eventsSlider() {
		$('.events-slider').each((index, value) => {

			this.initCarousel(value);

		});
	},

	placesSlider() {
		$('.places-slider').each((index, value) => {

			this.initCarousel(value);

		});
	},

	linkBoxesSlider(){
		
		$('.snookfun-slider').each((index, value) => {
			
			$(value).find('.snookfun-slider__prev').on( 'click', function() {
				$(value).flickity('previous');
			});
			$(value).find('.snookfun-slider__next').on( 'click', function() {
				$(value).flickity('next');
			});
			
			this.initCarousel(value);

		});
		
	},

	initCarousel(aCarousel) {

		let enableSliderBehavior = $(aCarousel).find('.carousel-cell').length > 1;

		let eventsSlider = $(aCarousel).flickity({
			// options
			cellAlign: 'left',
			contain: true,
			freeScroll: false,
			wrapAround: true,
			pageDots: true,
			prevNextButtons: enableSliderBehavior,
			draggable: enableSliderBehavior,
			autoPlay: true,
			pauseAutoPlayOnHover: true
		});

	},

	eventFilter() {

		let filters = $('.event-filter .snookfun-form-checkbox');

		filters.each((aIndex, aElement) => {

			let filter = $(aElement);
			filter.on('click', (e) => {
				filters.removeClass('selected');
				filter.addClass('selected');
				let name = filter.data('name');
				this.setGetParameter('filter', name);
			})

		});

	},

	setGetParameter(paramName, paramValue) {
		let url = window.location.href;
		let hash = location.hash;
		url = url.replace(hash, '');
		if (url.indexOf(paramName + "=") >= 0) {
			let prefix = url.substring(0, url.indexOf(paramName));
			let suffix = url.substring(url.indexOf(paramName));
			suffix = suffix.substring(suffix.indexOf("=") + 1);
			suffix = (suffix.indexOf("&") >= 0) ? suffix.substring(suffix.indexOf("&")) : "";
			url = prefix + paramName + "=" + paramValue + suffix;
		}
		else {
			if (url.indexOf("?") < 0)
				url += "?" + paramName + "=" + paramValue;
			else
				url += "&" + paramName + "=" + paramValue;
		}
		window.location.href = url + hash;
	},

	subSavoirFaireLink(){

		$('.snookfun-content-slider__list-item').each((aIndex, aElement) => {
			let link = $(aElement).find(".snookfun-link");
			let id = link.data('id');
			link.on('mouseover', (e) => {
				
				$('.snookfun-content-slider__img').each((bIndex, bElement) => {
					let imgContainer = $(bElement);
					imgContainer.hide();
				});
				$('.ssf-image-'+id).show();
				$('.snookfun-content-slider__description').each((bIndex, bElement) => {
					let imgDescription = $(bElement);
					imgDescription.hide();
				});
				$('.ssf-descr-'+id).show();
			});
		});
	},
	
	toggleFooterLinks(){
		let trigger = $(".snookfun-footer__trigger");
		let list = $(".snookfun-footer__list");
		
		trigger.each(()=>{
			trigger.on("click", (e) => {
				e.preventDefault();
				list.removeClass("active");
				$(this).parent().next().addClass("active");
			});
		})
	}
};

Apart.init();